import portsApi from '@/framework/ports/portsApi';

const DocumentFrontend = {
  getCookies: (): Promise<string> => portsApi.invoke('Document.getCookies'),
  getElementScrollLeft: (id: string): Promise<Element> =>
    portsApi.invoke('Document.getElementScrollLeft', [id]),
  setTitle: (title: string): Promise<Element> =>
    portsApi.invoke('Document.setTitle', [title]),
  setMetaDescription: (description: string): Promise<Element> =>
    portsApi.invoke('Document.setMetaDescription', [description]),
  manageRobotsTag: (
    noindex?: boolean,
    notranslate?: boolean
  ): Promise<Element> =>
    portsApi.invoke('Document.manageRobotsTag', [noindex, notranslate]),
  setCanonicalTag: (pageUrl: string): Promise<Element> =>
    portsApi.invoke('Document.setCanonicalTag', [pageUrl]),
  removeHreflangTags: (canonical?: object) =>
    portsApi.invoke('Document.removeHreflangTags', [canonical]),
  setSchemaMarkUp: (data: string): Promise<Element> =>
    portsApi.invoke('Document.setSchemaMarkUp', [data]),
  setBodyNonScrollable: () => portsApi.invoke('Document.setBodyNonScrollable'),
  setBodyTopPosition: (shouldCalculateTopPosition?: boolean) =>
    portsApi.invoke('Document.setBodyTopPosition', [
      shouldCalculateTopPosition,
    ]),
  setBodyScrollable: () => portsApi.invoke('Document.setBodyScrollable'),

  OpenGraph: {
    setTitle: (title: string): Promise<Element> =>
      portsApi.invoke('Document.OpenGraph.setTitle', [title]),
    setURL: (pageUrl: string): Promise<Element> =>
      portsApi.invoke('Document.OpenGraph.setURL', [pageUrl]),
    setDescription: (description: string): Promise<Element> =>
      portsApi.invoke('Document.OpenGraph.setDescription', [description]),
    setImage: (imageUrl: string): Promise<Element> =>
      portsApi.invoke('Document.OpenGraph.setImage', [imageUrl]),
    setType: (type: string): Promise<Element> =>
      portsApi.invoke('Document.OpenGraph.setType', [type]),
  },

  TwitterCards: {
    setTitle: (title: string): Promise<Element> =>
      portsApi.invoke('Document.TwitterCards.setTitle', [title]),
    setURL: (pageUrl: string): Promise<Element> =>
      portsApi.invoke('Document.TwitterCards.setURL', [pageUrl]),
    setDescription: (description: string): Promise<Element> =>
      portsApi.invoke('Document.TwitterCards.setDescription', [description]),
    setImage: (imageUrl: string): Promise<Element> =>
      portsApi.invoke('Document.TwitterCards.setImage', [imageUrl]),
    setType: (type: string): Promise<Element> =>
      portsApi.invoke('Document.TwitterCards.setType', [type]),
  },

  enableZoom: (): Promise<void> => portsApi.invoke('Document.enableZoom'),
  disableZoom: (): Promise<void> => portsApi.invoke('Document.disableZoom'),
};

export default DocumentFrontend;
